import { render, staticRenderFns } from "./AddressSave.vue?vue&type=template&id=5c905c02"
import script from "./AddressSave.vue?vue&type=script&lang=js"
export * from "./AddressSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports